import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { TextField, InputAdornment, Button, CircularProgress } from '@material-ui/core';
import { FeaturedPlayListOutlined, Search } from '@material-ui/icons';
import { useForm, Controller } from 'react-hook-form';
import { getTokenSii } from '../utils/getTokenSii';
import { apiSettings } from '../utils/ApiSettings';

const FormUser = props => {

    const [isLoading, setIsLoading] = useState(false);

    const { setData, setSnackbar } = props;

    const classes = useStyles();
    const { handleSubmit, errors, control, reset } = useForm(); 

    const onSubmit = async data => {
        setIsLoading(true);
        const token = await getTokenSii();
        const response = await consultarExpedienteMercantil(token, data.id);
        reset({id: ''});
        setIsLoading(false);
        setData(response);
    }

    const consultarExpedienteMercantil = async (token, id) => {
        const { uri, credentials } = apiSettings;
        credentials.token = token;
        credentials.matricula = "";
        credentials.identificacion = id;
        credentials.tipo = "A";

        try {
            const response = await fetch(`${uri}consultarExpedienteMercantil`, {
                method: 'POST',
                body: JSON.stringify(credentials)
            });
         
            if(response.ok) {
                const data = await response.json();

                if(data.codigoerror === '0000') {
                    if(data.ultanorenovado === (new Date().getFullYear() -1).toString()) {
                        return data;
                    }else {
                        setSnackbar(e => ({...e, visible: true, message: `El registro debe tener como último año renovado el ${ new Date().getFullYear() -1 }`}));
                    }
                }else {
                    setSnackbar(e => ({...e, visible: true, message: 'No se obtuvo ningún resultado.'}));
                    return false;
                }
            }
        }catch (e) {
            return false;
        }
    }

    return (
        <form className={classes.container} onSubmit={handleSubmit(onSubmit)}>

            <div className={classes.title}>Buscar registro público</div>

            <Controller 
                name='id'
                control={control}
                defaultValue=''
                render={({onChange, value}) => (
                    <TextField
                        disabled={isLoading}
                        error={ errors.id ? true : false }
                        label='Identificación'
                        helperText={ errors.id ? errors.id.message : 'Ingrese el número de cédula o nit' }
                        fullWidth
                        size='small'
                        type='number'
                        variant="outlined"
                        style={{ marginBottom: 15 }}
                        value={value || ''}
                        onChange={onChange}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <FeaturedPlayListOutlined htmlColor='grey' />
                                </InputAdornment>
                            )
                        }}
                    />
                )}
                rules={{
                    required: '* Campo obligatorio',
                    pattern: {
                        value: /^[1-9][0-9]{6,9}$/,
                        message: 'La identificación no es correcta'
                    }
                }}
            />

            <Button
                variant="contained"
                //color="primary"
                startIcon={ isLoading ? <CircularProgress size={20} color='inherit' /> : <Search /> }
                fullWidth
                disabled={isLoading}
                style={{ paddingTop: 7, paddingBottom: 7, background: '#4caf50', color: '#fff' }}
                size='medium'
                type='submit'
            >
                { isLoading ? 'Buscando...' : 'Buscar' }
            </Button>

        </form>
    );
}

const useStyles = makeStyles({
    container: {
        background: '#fff',
        width: 400,
        margin: 10,
        padding: 20,
        borderRadius: 6,
        borderWidth: 1,
        borderColor: '#CACFD2',
        borderStyle: 'solid'
    },
    title: {
        marginBottom: 25,
        fontFamily: 'Roboto',
        fontSize: 20,
        color: 'rgba(0, 0, 0, .8)',
        fontWeight: '500',
        letterSpacing: .2
    },
    divider: {
        marginBottom: 15,
        fontFamily: 'Roboto',
        color: 'grey',
        textAlign: 'center',
    }
});

export default FormUser;